import React from 'react'

const MonthlyUsage = ({ quota }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Monthly Usage</h3>
        <span className="text-sm text-gray-600">{quota.usage || 0} / {quota.limit || 0} calls</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
        <div className="bg-blue-600 h-3 rounded-full transition-all duration-500" style={{ width: `${quota.usagePercentage || 0}%` }}></div>
      </div>
      <div className="flex justify-between text-sm text-gray-600">
        <span>{quota.usagePercentage?.toFixed(0) || 0}% used</span>
        <span>{quota.remaining || 0} calls remaining</span>
      </div>
    </div>
  )
}

export default MonthlyUsage